!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("preact")) : "function" == typeof define && define.amd ? define(["exports", "preact"], t) : t((n = n || self).preactContext = {}, n.preact);
}(this, function (n, t) {
  "use strict";

  var _i = function i(n, t) {
    return (_i = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (n, t) {
      n.__proto__ = t;
    } || function (n, t) {
      for (var i in t) {
        t.hasOwnProperty(i) && (n[i] = t[i]);
      }
    })(n, t);
  };

  function r(n, t) {
    function r() {
      this.constructor = n;
    }

    _i(n, t), n.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }

  var e = {
    register: function register(n) {
      console.warn("Consumer used without a Provider");
    },
    unregister: function unregister(n) {},
    val: function val(n) {}
  };

  function u(n) {
    var t = n.children;
    return {
      child: 1 === t.length ? t[0] : null,
      children: t
    };
  }

  function o(n) {
    return u(n).child || "render" in n && n.render;
  }

  var c = 1073741823,
      f = function f() {
    return c;
  },
      s = 0;

  function a(n, i) {
    var a = "_preactContextProvider-" + s++;
    return {
      Provider: function (n) {
        function e(t) {
          var r = n.call(this, t) || this;
          return r.t = function (n, t) {
            var i = [],
                r = n,
                e = function e(n) {
              return 0 | t(r, n);
            };

            return {
              register: function register(n) {
                i.push(n), n(r, e(r));
              },
              unregister: function unregister(n) {
                i = i.filter(function (t) {
                  return t !== n;
                });
              },
              val: function val(n) {
                if (void 0 === n || n == r) return r;
                var t = e(n);
                return r = n, i.forEach(function (i) {
                  return i(n, t);
                }), r;
              }
            };
          }(t.value, i || f), r;
        }

        return r(e, n), e.prototype.getChildContext = function () {
          var n;
          return (n = {})[a] = this.t, n;
        }, e.prototype.componentDidUpdate = function () {
          this.t.val(this.props.value);
        }, e.prototype.render = function () {
          var n = u(this.props),
              i = n.child,
              r = n.children;
          return i || t.h("span", null, r);
        }, e;
      }(t.Component),
      Consumer: function (t) {
        function i(i, r) {
          var e = t.call(this, i, r) || this;
          return e.i = function (n, t) {
            var i = e.props.unstable_observedBits,
                r = void 0 === i || null === i ? c : i;
            0 != ((r |= 0) & t) && e.setState({
              value: n
            });
          }, e.state = {
            value: e.u().val() || n
          }, e;
        }

        return r(i, t), i.prototype.componentDidMount = function () {
          this.u().register(this.i);
        }, i.prototype.shouldComponentUpdate = function (n, t) {
          return this.state.value !== t.value || o(this.props) !== o(n);
        }, i.prototype.componentWillUnmount = function () {
          this.u().unregister(this.i);
        }, i.prototype.componentDidUpdate = function (n, t, i) {
          var r = i[a];
          r !== this.context[a] && ((r || e).unregister(this.i), this.componentDidMount());
        }, i.prototype.render = function () {
          var n = "render" in this.props && this.props.render,
              t = o(this.props);
          if (n && n !== t && console.warn("Both children and a render function are defined. Children will be used"), "function" == typeof t) return t(this.state.value);
          console.warn("Consumer is expecting a function as one and only child but didn't find any");
        }, i.prototype.u = function () {
          return this.context[a] || e;
        }, i;
      }(t.Component)
    };
  }

  var h = a;
  n.default = a, n.createContext = h, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});